import { createSelector } from "@reduxjs/toolkit"
import { selectedAccessoriesSelector } from "components/shopFeatures/accessories/accessoriesSelectors"
import { selectedColorSelector } from "components/shopFeatures/color/colorSelectors"
import { selectedDetailingSelector } from "components/shopFeatures/detailing/detailingSelectors"
import { selectedUpholsterySelector } from "components/shopFeatures/upholstery/upholsterySelectors"

// export const selectedComponentsForAnalyticsSelector = createSelector<
//   RootState,
//   WizardState["model"],
//   WizardState["price"],
//   ReturnType<typeof selectedDetailingSelector>,
//   ReturnType<typeof selectedColorSelector>,
//   ReturnType<typeof selectedUpholsterySelector>,
//   ReturnType<typeof selectedAccessoriesSelector>,
//   SelectedComponentsForAnalytics | null
// >(
//   (state) => state.wizard.model,
//   (state) => state.wizard.price,
//   selectedDetailingSelector,
//   selectedColorSelector,
//   selectedUpholsterySelector,
//   selectedAccessoriesSelector,
//   (model, price, detailing, color, upholstery, accessories) => {
//     if (!model || !price || !detailing || !color || !upholstery) return null

//     return {
//       modelName: model.name,
//       modelId: model.id,
//       totalPrice: price.totalPrice,
//       detailingName: detailing.details.name,
//       colorName: color.details.name,
//       upholsteryName: upholstery.details.name,
//       accessories: accessories.map((accessory) => ({
//         name: accessory.details.name,
//         id: accessory.details.code,
//         price: accessory.price.totalPrice,
//       })),
//     }
//   }
// )
export const selectedComponentsForAnalyticsSelector = createSelector(
  (state) => state.wizard.model,
  (state) => state.wizard.price,
  selectedDetailingSelector,
  selectedColorSelector,
  selectedUpholsterySelector,
  selectedAccessoriesSelector,
  (model, price, detailing, color, upholstery, accessories) => {
    if (!model || !price || !detailing || !color || !upholstery) return null

    return {
      modelName: model.name,
      modelId: model.id,
      totalPrice: price.totalPrice,
      detailingName: detailing.details.name,
      colorName: color.details.name,
      upholsteryName: upholstery.details.name,
      accessories: accessories.map((accessory) => ({
        name: accessory.details.name,
        id: accessory.details.code,
        price: accessory.price.totalPrice,
      })),
    }
  }
)
